<style lang="stylus" scoped>
@import './cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-area {
  margin-top: 20px;
}
</style>

<template>
  <div>
    <dimension-dialog v-if="showExport" @hideExport="hideExport1"  :moduleName="moduleName" :tabNames="'monthly'"/>
    <detailsData v-if="showDetails" :dimObj="getNewDimObj()" :fuelType="fuelType" :priviceName="priviceName" :value="value4" :registProvcode="registProvcode" @closeDetails="closeDetails"/>
    <div v-else class="home-main">
      <div class="mark" v-if="mark">
        <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
      </div>
      <tabTon :titleArr="titleArr" :changeType="changeType" :dataType="dataType" :path="path">
        <el-button v-show="hideExport" style="float: right;margin-right: 10px;margin-top: 26px;" @click="exportDate">导出</el-button>
        <el-select v-model="fuelType" @change="changeFuelType" style="width:150px;float: right;margin-right: 10px;margin-top: 26px;" placeholder="请选择燃油类型">
          <el-option
            v-for="(item,index) in fuelTypeList"
            :label="item.label"
            :value="item.value"
            :key="index"
          />
        </el-select>
      </tabTon>
      <div class="map-data">
        <div class="map-area">
          <!--el-date-picker
            v-model="value4"
            type="month"
            placeholder="选择月"
            style="position: absolute;left: 40%;top: -3px;z-index:100"
            value-format="yyyy-MM"
            @change="changeTime"
          ></el-date-picker-->
          <div style="position: absolute;left: 40%;top: -5px;z-index:100;">
            <dimension-popover ref="objDimensionPopover" :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true" :tabNames="'monthly'" />
          </div>
          <home-map
            :dataType="dataType"
            :title="titleArr[dataType].title"
            :mapRangeList="mapRangeList"
            :dataItem="dataItem"
            @getDetails="getDetails"
          ></home-map>
          <mapBox v-if="showtip"/>
        </div>
        <map-card :cardItem="dataItem"  @getDetails="getDetails"></map-card>
      </div>
    </div>
    <div class="bottom-top" v-if="!showDetails">
      <h4><img src="../../../assets/images/title.png"> <span>说明</span></h4>
      <div>1、以当月的每天运营车辆数为维度进行区分；</div>
      <div>2、合计数据：每辆车每天运营过记一次（辆）；</div>
      <div>3、各时间段数据：每辆车每天在该时间段运营过记一次（辆）；</div>
      <div>4、按车辆注册省：该省入网车辆在全国运营的车辆数；</div>
      <div>5、按车辆运营省：全国货运平台车辆在该省运营的车辆数（注：在统计时间内，一辆车在某省运营，则在该省计为1辆）。</div>
    </div>
  </div>
</template>

<script>
import homeMap from './components/map.vue'
import mapCard from './components/mapCard.vue'
import tabTon from '../component/tabTon.vue'
import http from '@/api/freight'
import Util from '@/utils/util'
// import cityData from './map-data/get-city-value.js'
import Cookies from 'js-cookie'
import detailsData from './components/details.vue'
//import exportDate from '@/components/exportDate'
//import exportDate from '@/components/exportDate/daphne/dialog.vue'
import { hideExport } from '@/utils/tools'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'
import { getFuelTypeList , getFuelTypeCode } from '@/utils/dictionary'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
export default {
  name: 'home',
  components: {
    homeMap,
    mapCard,
    tabTon,
    detailsData,
    dimensionDialog,
    dimensionPopover,
  },
  data() {
    let fuelTypeList = getFuelTypeList();
    let value4=Util.lastTime(new Date());
    let arr = value4.split('-')
    let dimObj={
      year: arr[0],
      month: arr[1],
      type: "0",
    };
    let firstLoaded=true;
    return {
      firstLoaded,
      fuelTypeList,
      fuelType:"",
      hideExport:hideExport,
      showtip:false,
      moduleName:"operatorTimeVehicle",
       priviceName:'',
      registProvcode:'',
      showExport:false,//控制批量导出
      path:"carTime",
      //   cityData: [],
      areaList: [], //省列表
      dataType: 0, //点击省份详情列表
      titleArr: [
        {
          title: '',
          value: '',
          key: 'timeSubtotal'
        },
        {
          title: '0(含)-6点',
          value: '',
          key: 'time_0_6'
        },
        {
          title: '6(含)-12点',
          value: '',
          key: 'time_6_12'
        },
        {
          title: '12(含)-18点',
          value: '',
          key: 'time_12_18'
        },
        {
          title: '18(含)-24点',
          value: '',
          key: 'time_18_24'
        }
      ],
      progressNum: 0, //进度条进度
      mark: false, //是否显示遮罩层
      value4,
      mapRangeList: [], //地图图例
      dataItem: [], // 地图数据
      nounArr: ['第1-3名', '第4-7名', '第8-12名', '第13-18名', '第19-31名'], //地图图例汉字
      showDetails:false,
      dimObj,
    }
  },
  watch: {},
  computed: {},
  created() {
    if(Cookies.get('userType')!=2){
        this.initData()
     }
  },
  methods: {
    getNewDimObj(){
      if(Cookies.get('userType')==2){
        this.dimObj.month = '0' + (Number(this.dimObj.month) - 1);
      }
      return cloneDeep(this.dimObj)
    },
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
     // 取消导出
    hideExport1(){
      this.showExport=false
      this.initData()
    },
     getDetails(index,name,registProvcode) {
      this.priviceName=name
      this.registProvcode=registProvcode
      this.showDetails = true
    },
    closeDetails(){
      this.showDetails=false
      this.initData()
    },
    changeType(num) {
      this.dataType = num
      this.initData()
    },
    changeFuelType(){
      this.initData()
    },
    initTit() {
      let that = this
      let energyType = getFuelTypeCode(this.fuelType)
      let arr = that.value4.split('-')
      let type = get(this,"dimObj.type","0")
      http
        .carTimeAll({
          year: arr[1]=='00'?arr[0]-1:arr[0],
          month: arr[1]=='00'?'12':arr[1],
          energyType,
          type,
        })
        .then(e => {
          let arr = [...that.titleArr]
          arr[0].value = e.data.timeSubtotal
          arr[1].value = e.data.time_0_6
          arr[2].value = e.data.time_6_12
          arr[3].value = e.data.time_12_18
          arr[4].value = e.data.time_18_24
          that.titleArr = [...arr]
        })
    },
    initData() {
      let that = this
      let energyType = getFuelTypeCode(this.fuelType)
      let arr = that.value4.split('-')
      let type = get(this,"dimObj.type","0")
      let firstPageLoad=this.firstLoaded?1:0;
      http
        .carTime({
          condition: that.titleArr[that.dataType].key,
          registYear: arr[1]=='00'?arr[0]-1:arr[0],
          registMonth: arr[1]=='00'?'12':arr[1],
          energyType,
          type,
          firstPageLoad,
        })
        .then(e => {
        	/*if(e.data&&e.data.time){
        		that.value4=e.data.time;
        	}*/
          if(this.firstLoaded){
            this.firstLoaded=false;
            if(e.data&&e.data.time){
              that.value4=e.data.time;
              let arr = that.value4.split('-')
              set(this,"dimObj.year",arr[0])
              set(this,"dimObj.month",arr[1])
              this.$refs.objDimensionPopover.setCtrlValue();
            }
          }
        	that.initTit();
          if (e.data && e.data.mapRangeList) {
            for (let i = 0; i < e.data.mapRangeList.length; i++) {
              e.data.mapRangeList[i].label = that.nounArr[i]
              // if (e.data.mapRangeList[i].end == -1) {
              //   e.data.mapRangeList[i].label =
              //     e.data.mapRangeList[i].start + ' 以上'
              //   delete e.data.mapRangeList[i].end
              // }
            }
            that.mapRangeList = [...e.data.mapRangeList]
            that.dataItem = that.handleSeriesData({
              data: e.data.resultList,
              index: that.dataType
            })
            this.showtip=false
          } else {
            that.dataItem = []
            that.mapRangeList=[{end:0,start:0,label:"无"}]
            this.showtip=true
          }
        })
    },
    changeDimension(e){
      if(e.isOk){
        this.value4 = e.year+"-"+e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      this.initData()
    },
    handleSeriesData({ index = 0, data }) {
      let that = this
      let arrs = JSON.stringify(data)
      let handleArr = JSON.parse(arrs)
      handleArr.forEach(e => {
        e.name = e.registProvince.slice(0, e.registProvince.length - 1)
        e.yyValue = e.yyOperatorSubtotal
        if (index == 0) {
          e.value = e.timeSubtotal
        } else if (index == 1) {
          e.value = e.time_0_6
        } else if (index == 2) {
          e.value = e.time_6_12
        } else if (index == 3) {
          e.value = e.time_12_18
        } else if (index == 4) {
          e.value = e.time_18_24
        } else {
          e.value = e.timeSubtotal
        }
      })
      return handleArr
    },
    exportDate() {
      this.showExport=true
      return
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      window.times = setInterval(function() {
        http.progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(window.times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      let arr = that.value4.split('-')
      window.location.assign(
        http.carTimeExport({
          registYear: arr[1]=='00'?arr[0]-1:arr[0],
          registMonth: arr[1]=='00'?'12':arr[1],
          reqId
        })
      )
    }
  }
}
</script>
